module.exports = __webpack_public_path__ + "static/media/globe.b50cddc5.svg";